export const surfturf = {
  name: 'Surf & Turf',
  color: [0.8705882352941177, 0.47843137254901963, 0.13333333333333333, 1],
  bg: [0.9568627450980393, 0.8, 0.4392156862745098, 1],
  grid1: [0.12549019607843137, 0.5803921568627451, 0.5450980392156862, 1],
  grid2: [0.41568627450980394, 0.6941176470588235, 0.5294117647058824, 1],
}
